let state = {
    info: null,
    comics: [],
    comic: [],
    chapter: [],
    votes: {},
    vote_token: null,
};

export default state;
